import { useEffect, useState, useRef, useCallback } from "react";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import DocumentSnippetIconTooltip from "../ui-icons/table/DocumentSnippetIconTooltip";
import SortIcon from "../ui-icons/table/SortIcon";
import { useAppSelector, useAppDispatch } from "src/hooks/redux";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import { EmptyList } from "../EmptyList";
import { UserAvatar } from "../ui/avatar/Avatar";
import { OnApprovalIcon, OnReviewIcon, OnRevisionIcon, RejectedIcon } from "../ui-icons/table/codeStatus";
import { Modal } from "src/components/DialogComponent";
import TGButton from "../ui/TGButton";
import { getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { myDocumentsListName, versionsByDocumentListName, siteUrl } from "src/api/config";
import Datepicker from "react-tailwindcss-datepicker";
import PeoplePicker from "../ui/form/peoplePicker";
import { addUsers } from "src/modules/users/actions";
import PencilIcon from "src/pages/Reports/ReportsIcons.tsx/PencilIcon";
import Loading from "../Loading";
import Select from "../ui/form/select/select";
import { emailQueueListName } from "src/api/config/email.config";
import { renderHighlightedText, highlightQueryInText } from "src/utils/searchHighlight";

const ReportDocumentsTable = (props: any) => {

    const { data, customLoading, searchQuery = "", setScrollDown, filters } = props;
    const [sortData, setSortData] = useState<any>([]);
    const [query, setQuery] = useSearchParams();
    const users: any = useAppSelector(selectUsers);
    const [open, setOpen] = useState(false);
    const [typeModal, setTypeModal] = useState<any>(null);
    const [changeDocument, setChangeDocument] = useState<any>(null);
    const [changeData, setChangeData] = useState<any>(null);
    const dispatch = useAppDispatch();
    const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
    const [updateLoading, setUpdateLoading] = useState(false);

    const ITEMS_PER_PAGE = 50;
    const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const [tableHeaderContent, setTableHeaderContent] = useState<any>({
        Code: {
            title: "Код",
            sort: true,
            style: { width: "9.9%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        Title: {
            title: "Наименование",
            sort: true,
            style: { width: "9.8%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        CollectionStr: {
            title: "Коллекция",
            sort: true,
            style: { width: "10.57%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        DepartmentStr: {
            title: "Подразделение/Функция",
            sort: true,
            style: { width: "12.71%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        SectorStr: {
            title: "Колонна/Направление/Отдел",
            sort: true,
            style: { width: "14.05%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        DocTypeStr: {
            title: "Тип",
            sort: true,
            style: { width: "2.84%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        Version: {
            title: "Версия",
            sort: true,
            style: { width: "4.23%" },
            sortDirection: 'default',
            sortType: 'number'
        },
        AuthorEmailStr: {
            title: "Создатель",
            sort: false,
            style: { width: "16.05%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        PublicationDate: {
            title: "Дата публикации",
            sort: true,
            style: { width: "8.95%" },
            sortDirection: 'default',
            sortType: 'date'
        },
        StatusStr: {
            title: "Статус",
            sort: true,
            style: { width: "10.45%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        DateForRevision: {
            title: "Дата пересмотра",
            sort: true,
            style: { width: "9%" },
            sortDirection: 'default',
            sortType: 'date'
        },
        ResponsibleForRevisionEmailStr: {
            title: "Ответственный за пересмотр",
            sort: false,
            style: { width: "17.18%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        CriticalStr: {
            title: "Критичность",
            sort: true,
            style: { width: "12.12%" },
            sortDirection: 'default',
            sortType: 'string'
        },
    });

    const openDocumentCard = (id: number, version?: number) => {
        const newSearchParams = new URLSearchParams(query);
        newSearchParams.set("documentCard", id.toString());
        if (version) {
            newSearchParams.set("version", version.toString());
        }
        setQuery(newSearchParams);
    }

    const sortDataHandle = (sortField: string, sortDirection: string, sortType: string) => {
        const tempTableHeaderContent = { ...tableHeaderContent };
        const tempData = [...data.map((item: any) => { return { ...item, ...{ Code: `${item.Code}.${item.Index}`, CollectionStr: item.Collection.get_lookupValue(), DepartmentStr: item.Department.get_lookupValue(), SectorStr: item.Sector.get_lookupValue(), DocTypeStr: item.DocType.get_lookupValue(), Version: item.version, AuthorEmailStr: users[item.AuthorEmail] && users[item.AuthorEmail]['displayName'], StatusStr: item.Status.get_lookupValue(), ResponsibleForRevisionEmailStr: users[item.ResponsibleForRevisionEmail || item.AuthorEmail] && users[item.ResponsibleForRevisionEmail || item.AuthorEmail]['displayName'], CriticalStr: item.Critical && 'Критичный' || 'Не критичный' } } })];
        Object.keys(tempTableHeaderContent).map((key: string) => {
            tempTableHeaderContent[key]['sortDirection'] = 'default';
        });
        if (sortDirection === 'default') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'desc';
        }
        if (sortDirection === 'desc') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'asc';
        }
        if (sortDirection === 'asc') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'default';
            setSortData([...data]);
        }
        if (sortType === 'number') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                tempData.sort((a: any, b: any) => parseFloat(a[sortField]) - parseFloat(b[sortField]));
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                tempData.sort((a: any, b: any) => parseFloat(b[sortField]) - parseFloat(a[sortField]));
            }
        }
        if (sortType === 'string') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                tempData.sort((a: any, b: any) => {
                    return a[sortField].localeCompare(b[sortField]);
                });
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                tempData.sort((a: any, b: any) => {
                    return b[sortField].localeCompare(a[sortField]);
                });
            }
        }
        if (sortType === 'date') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                const distantFuture = new Date(8640000000000000);
                tempData.sort((a: any, b: any) => {
                    let dateA = a[sortField] || distantFuture;
                    let dateB = b[sortField] || distantFuture;
                    return dateA.getTime() - dateB.getTime();
                });
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                const distantFuture = new Date(8640000000000000);
                tempData.sort((a: any, b: any) => {
                    let dateA = a[sortField] || distantFuture;
                    let dateB = b[sortField] || distantFuture;
                    return dateB.getTime() - dateA.getTime();
                });
            }
        }
        setTableHeaderContent({ ...tempTableHeaderContent });
        setSortData([...tempData]);
    }

    useEffect(() => {
        setSortData([...data]);
        const tempTableHeaderContent = { ...tableHeaderContent };
        Object.keys(tempTableHeaderContent).map((key: string) => {
            tempTableHeaderContent[key]['sortDirection'] = 'default';
        });
        setTableHeaderContent({ ...tempTableHeaderContent });
    }, [data]);

    const updateDataHandle = () => {
        setUpdateLoading(true);
        updateItemRequest({ listName: changeDocument.MainDocument && versionsByDocumentListName || myDocumentsListName, body: changeData }).then(() => {
            let tempData = [...sortData];
            if (changeData && changeData.hasOwnProperty('Critical')) {
                tempData.forEach((item: any) => {
                    if (item.ID === changeDocument.ID) {
                        item.Critical = changeData.Critical
                    }
                });
                setSortData([...tempData]);
                setUpdateLoading(false);
                setOpen(!open);
            }
            if (changeData && changeData.hasOwnProperty('DateForRevision')) {
                tempData.forEach((item: any) => {
                    if (item.ID === changeDocument.ID) {
                        item.DateForRevision = changeData.DateForRevision
                    }
                });
                setSortData([...tempData]);
                setUpdateLoading(false);
                setOpen(!open);
            }
            if (changeData && changeData.hasOwnProperty('ResponsibleForRevision')) {
                tempData.forEach((item: any) => {
                    if (item.ID === changeDocument.ID) {
                        getItemsRequest({ listName: emailQueueListName, filters: { CheckDoc: `^${item.ID}`, Recepients: `${item.ResponsibleForRevisionEmail}*`.toLowerCase(), Body: 'пересмотреть документ*' } }).then(results => {
                            if (results.items.length > 0) {
                                let updateData: any = [];
                                results.items.forEach(item => {
                                    updateData = [...updateData, {
                                        ID: item.ID, Recepients: changeData.ResponsibleForRevision.toLowerCase(), IsSent: false, Body: `Здравствуйте ${(users[changeData.ResponsibleForRevision.toLowerCase()] &&
                                            users[changeData.ResponsibleForRevision.toLowerCase()]["displayName"]) ||
                                            changeData.ResponsibleForRevision.toLowerCase() ||
                                            ""
                                            },<br/><br/>Уведомляем Вас о необходимости пересмотреть документ, так как Вы являетесь ответственным за его пересмотр:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${changeDocument.ID}">${changeDocument.Title}</a><br/><br/>Срок пересмотра: ${changeDocument.DateForRevision.format("DD.MM.YYYY")}`
                                    }];
                                });
                                console.log('updateData: ', updateData);
                                updateItemRequest({ listName: emailQueueListName, body: updateData[0], bodyArr: updateData }).then(() => {
                                    item.ResponsibleForRevisionEmail = changeData.ResponsibleForRevision;
                                    setSortData([...tempData]);
                                    setUpdateLoading(false);
                                    setOpen(!open);
                                });
                            } else {
                                item.ResponsibleForRevisionEmail = changeData.ResponsibleForRevision;
                                setSortData([...tempData]);
                                setUpdateLoading(false);
                                setOpen(!open);
                            }
                        })
                    }
                });
            }
        });
    }

    const handleScroll = useCallback(() => {
        const container = scrollContainerRef.current;
        if (!container) return;

        const { scrollTop, scrollHeight, clientHeight } = container;
        // Триггерим за 100px до конца для плавности
        if (scrollHeight - scrollTop - clientHeight < 100) {
            setScrollDown(true);
            setVisibleCount(prev => {
                const newCount = prev + ITEMS_PER_PAGE;
                return newCount >= sortData.length ? sortData.length : newCount;
            });
        }
    }, [sortData.length]);

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container) return;
        container.addEventListener('scroll', handleScroll, { passive: true });
        return () => container.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    useEffect(() => {
        setVisibleCount(ITEMS_PER_PAGE);
    }, [filters]);

    return (
        <FlexCol className="w-full">
            <FlexCol className="relative">
                <div ref={scrollContainerRef} id="owd_calendar_wrapper" className="flex flex-col relative pb-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-h-[calc(100vh-230px)] min-h-[170px]">
                    <FlexRow className="pb-5 sticky-custom max-h-[65px] w-full bg-white pt-5 pl-20 pr-10 gap-5 min-w-[2467px] z-10">
                        {Object.keys(tableHeaderContent).map((fieldKey) => {
                            const key: string = fieldKey;
                            return (
                                <TableHeaderColumn
                                    key={fieldKey}
                                    sortField={fieldKey}
                                    tableHeaderContent={tableHeaderContent[key]}
                                    sortDataHandle={sortDataHandle}
                                />
                            );
                        })}
                    </FlexRow>
                    <FlexCol className="divide-y grow w-full px-10 min-w-[2467px]">
                        {sortData.map((item: any, idx: number) => (
                            <FlexRow
                                className="relative py-4 rounded-lg -mx-2 px-2 gap-5 cursor-pointer text-[#637381] hover:bg-[#F3F4F6]"
                                key={item.ID}
                                onClick={() => openDocumentCard(item.MainDocument && item.MainDocument.id || item.ID, (item.MainDocument && item.ID || item?.MainDocument?.id)
                                )}
                            >
                                <FlexCol style={{ width: "12.25%" }} className="break-all">
                                    <div className="flex items-start gap-x-[20px]">
                                        <DocumentSnippetIconTooltip
                                            highlightedText={item.searchMeta?.highlightedText}
                                            foundBy={item.searchMeta?.foundBy}
                                        />
                                        <span className="block text-sm font-normal not-italic min-w-0">{renderHighlightedText(highlightQueryInText(`${item.Code}.${item.Index}`, searchQuery))}</span>
                                    </div>
                                </FlexCol>
                                <FlexCol style={{ width: "9.8%" }} className="break-all">
                                    <span className="block text-sm font-normal not-italic">
                                        {renderHighlightedText(
                                            (item.searchMeta?.foundBy === "title" || item.searchMeta?.foundBy === "both") &&
                                                (item.searchMeta?.titleHighlightedText || item.searchMeta?.highlightedText)
                                                ? (item.searchMeta?.titleHighlightedText || item.searchMeta?.highlightedText)
                                                    .replace(/<mark>/g, "[highlight]")
                                                    .replace(/<\/mark>/g, "[/highlight]")
                                                : highlightQueryInText(item.Title, searchQuery)
                                        )}
                                    </span>
                                </FlexCol>
                                <FlexCol style={{ width: "10.57%" }} className="break-all">
                                    <span className="block text-sm font-normal not-italic">{item.Collection.get_lookupValue()}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "12.71%" }} className="break-all">
                                    <span className="block text-sm font-normal not-italic">{item.Department.get_lookupValue()}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "14.05%" }} className="break-all">
                                    <span className="block text-sm font-normal not-italic">{item.Sector.get_lookupValue()}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "2.84%" }} className="break-all">
                                    <span className="block text-sm font-normal not-italic">{item.DocType.get_lookupValue()}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "4.23%" }} className="break-all">
                                    <span className="block text-sm font-normal not-italic">{item.version}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "16.05%" }} className="break-all">
                                    {users[item.AuthorEmail] &&
                                        <span className="block text-sm font-normal not-italic">
                                            <div className="w-full flex items-center gap-2">
                                                <UserAvatar
                                                    avatar={users[item.AuthorEmail] && users[item.AuthorEmail].avatar}
                                                    shortName={users[item.AuthorEmail] && users[item.AuthorEmail].shortName}
                                                    displayName={users[item.AuthorEmail] && users[item.AuthorEmail].displayName}
                                                    email={item.AuthorEmail}
                                                />
                                                <div className="flex flex-col justify-center items-start">
                                                    <span className="text-sm text-[#111928]">{users[item.AuthorEmail] && users[item.AuthorEmail].displayName}</span>
                                                    <span className="text-sm text-[#637381]" dangerouslySetInnerHTML={{ __html: users[item.AuthorEmail] && users[item.AuthorEmail].jobTitle }} />
                                                </div>
                                            </div>
                                        </span> ||
                                        <span className="block text-sm font-normal not-italic animate-pulse">Получаем пользователя...</span>
                                    }
                                </FlexCol>
                                <FlexCol style={{ width: "8.95%" }} className="break-all">
                                    <span className="block text-sm font-normal not-italic">{!item.MainDocument && (item.Status.get_lookupId() === 3 || item.Status.get_lookupId() === 8) && moment(item.PublicationDate).format('DD.MM.YYYY') || 'Не опубликован'}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "10.45%" }} className="break-all">
                                    <div className="w-full flex items-center">
                                        {item.Status.get_lookupId() === 3 &&
                                            <OnReviewIcon />
                                        }
                                        {item.Status.get_lookupId() === 2 &&
                                            <OnRevisionIcon />
                                        }
                                        {item.Status.get_lookupId() === 4 &&
                                            <RejectedIcon />
                                        }
                                        {item.Status.get_lookupId() === 5 &&
                                            <OnApprovalIcon />
                                        }
                                        {item.Status.get_lookupId() === 8 &&
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                                                <path d="M11.4252 12.6012C11.4252 12.8512 11.2252 13.0512 10.9752 13.0512H1.7752C1.5252 13.0512 1.3252 12.8512 1.3252 12.6012V3.40117C1.3252 3.15117 1.5252 2.95117 1.7752 2.95117H10.1252L11.1252 1.82617C11.0752 1.82617 11.0502 1.82617 11.0002 1.82617H1.7752C0.925195 1.82617 0.200195 2.52617 0.200195 3.40117V12.6262C0.200195 13.5012 0.900195 14.2012 1.7752 14.2012H11.0002C11.8502 14.2012 12.5752 13.5012 12.5752 12.6262V3.62617L11.4502 4.87617V12.6012H11.4252Z" fill="#22AD5C" />
                                                <path d="M13.4503 0.925522C13.2253 0.725522 12.8753 0.725522 12.6503 0.975522L11.7253 2.00052L10.8753 2.95052L6.10033 8.30052L3.72533 6.12552C3.50033 5.92552 3.15033 5.92552 2.92533 6.15052C2.72533 6.37552 2.72533 6.72552 2.95033 6.95052L5.75033 9.50052C5.85033 9.60052 6.00033 9.65052 6.12533 9.65052H6.15033C6.30033 9.65052 6.45033 9.57552 6.55033 9.47552L11.4253 4.02552L12.4503 2.87552L13.5003 1.70052C13.7003 1.47552 13.7003 1.12552 13.4503 0.925522Z" fill="#22AD5C" />
                                            </svg>
                                        }
                                        {item.Status.get_lookupId() === 6 &&
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M14.0252 2.77422H8.2502L7.7252 1.77422C7.4502 1.27422 6.9502 0.949219 6.3752 0.949219H1.9752C1.1252 0.949219 0.450195 1.62422 0.450195 2.47422V13.5242C0.450195 14.3742 1.1252 15.0492 1.9752 15.0492H14.0502C14.9002 15.0492 15.5752 14.3742 15.5752 13.5242V4.29922C15.5752 3.44922 14.8752 2.77422 14.0252 2.77422ZM14.4502 13.5242C14.4502 13.7492 14.2752 13.9242 14.0502 13.9242H1.9752C1.7502 13.9242 1.5752 13.7492 1.5752 13.5242V2.47422C1.5752 2.24922 1.7502 2.07422 1.9752 2.07422H6.3752C6.5252 2.07422 6.6502 2.14922 6.7252 2.29922L7.4252 3.59922C7.5252 3.77422 7.7252 3.89922 7.9252 3.89922H14.0502C14.2752 3.89922 14.4502 4.07422 14.4502 4.29922V13.5242Z" fill="#8899A8" />
                                                <path d="M9.7998 8.94883L8.5748 10.1488V6.49883C8.5748 6.19883 8.3248 5.92383 7.9998 5.92383C7.6748 5.92383 7.4248 6.17383 7.4248 6.49883V10.1738L6.1748 8.94883C5.9498 8.72383 5.5998 8.72383 5.3748 8.94883C5.1498 9.17383 5.1498 9.52383 5.3748 9.74883L7.5748 11.8988C7.6748 11.9988 7.8248 12.0488 7.9748 12.0488C8.1248 12.0488 8.2498 11.9988 8.3748 11.8988L10.5748 9.74883C10.7998 9.52383 10.7998 9.17383 10.5748 8.94883C10.3748 8.72383 10.0248 8.72383 9.7998 8.94883Z" fill="#8899A8" />
                                            </svg>
                                        }
                                        &nbsp;&nbsp;{item.Status.get_lookupValue()}
                                    </div>
                                </FlexCol>
                                <FlexRow style={{ width: "9%" }} className="break-all gap-2">
                                    <span className="block text-sm font-normal not-italic">
                                        {
                                            item.Status.get_lookupId() === 3 && moment().unix() > moment(item.DateForRevision).clone().unix() &&
                                            <span className="text-[#D36E6E]">{moment(item.DateForRevision).format('DD.MM.YYYY')}</span>
                                            || item.Status.get_lookupId() === 3 && moment().unix() > moment(item.DateForRevision).clone().subtract(30, "days").unix() &&
                                            <span className="text-[#EAD16E]">{moment(item.DateForRevision).format('DD.MM.YYYY')}</span>
                                            || <span>{moment(item.DateForRevision).format('DD.MM.YYYY')}</span>
                                        }
                                    </span>
                                    {(currentUser.isAdmin || (currentUser.isCollectionEditor && currentUser.isCollectionEditor.length > 0 && currentUser.isCollectionEditor.find((collectionID: any) => collectionID === item.Collection.get_lookupId())) || (currentUser.isCollectionAdmin && currentUser.isCollectionAdmin.length > 0 && currentUser.isCollectionAdmin.find((collectionID: any) => collectionID === item.Collection.get_lookupId()))) &&
                                        <button
                                            className="hover:text-darkblue flex"
                                            onClick={e => {
                                                e.stopPropagation();
                                                setTypeModal('DateForRevision');
                                                setChangeDocument(item);
                                                setOpen(true);
                                            }}
                                        >
                                            <PencilIcon height="15" width="15" />
                                        </button>
                                    }
                                </FlexRow>
                                <FlexRow style={{ width: "17.18%" }} className="break-all gap-2">
                                    {users[item.ResponsibleForRevisionEmail || item.AuthorEmail] &&
                                        <>
                                            <span className="block text-sm font-normal not-italic">
                                                <div className="w-full flex items-center gap-2">
                                                    <UserAvatar
                                                        avatar={users[item.ResponsibleForRevisionEmail || item.AuthorEmail] && users[item.ResponsibleForRevisionEmail || item.AuthorEmail].avatar}
                                                        shortName={users[item.ResponsibleForRevisionEmail || item.AuthorEmail] && users[item.ResponsibleForRevisionEmail || item.AuthorEmail].shortName}
                                                        displayName={users[item.ResponsibleForRevisionEmail || item.AuthorEmail] && users[item.ResponsibleForRevisionEmail || item.AuthorEmail].displayName}
                                                        email={item.ResponsibleForRevisionEmail}
                                                    />
                                                    <div className="flex flex-col justify-center items-start">
                                                        <span className="text-sm text-[#111928]">{users[item.ResponsibleForRevisionEmail || item.AuthorEmail] && users[item.ResponsibleForRevisionEmail || item.AuthorEmail].displayName}</span>
                                                        <span className="text-sm text-[#637381]" dangerouslySetInnerHTML={{ __html: users[item.ResponsibleForRevisionEmail || item.AuthorEmail] && users[item.ResponsibleForRevisionEmail || item.AuthorEmail].jobTitle }} />
                                                    </div>
                                                </div>
                                            </span>
                                            {(currentUser.isAdmin || (currentUser.isCollectionEditor && currentUser.isCollectionEditor.length > 0 && currentUser.isCollectionEditor.find((collectionID: any) => collectionID === item.Collection.get_lookupId())) || (currentUser.isCollectionAdmin && currentUser.isCollectionAdmin.length > 0 && currentUser.isCollectionAdmin.find((collectionID: any) => collectionID === item.Collection.get_lookupId()))) &&
                                                <button
                                                    className="hover:text-darkblue flex"
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        setTypeModal('ResponsibleForRevision');
                                                        setChangeDocument(item);
                                                        setOpen(true);
                                                    }}
                                                >
                                                    <PencilIcon height="15" width="15" />
                                                </button>
                                            }
                                        </>
                                        ||
                                        <span className="block text-sm font-normal not-italic animate-pulse">Получаем пользователя...</span>
                                    }
                                </FlexRow>
                                <FlexRow style={{ width: "12.12%" }} className="break-all gap-2">
                                    <div className="flex gap-2">
                                        <svg className="mt-[5px]" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                            <circle cx="5" cy="5" r="5" fill={item.Critical && '#BA0C2F' || '#DFE4EA'} />
                                        </svg>
                                        &nbsp;&nbsp;{item.Critical && 'Критичный' || 'Не критичный'}
                                    </div>
                                    {(currentUser.isAdmin || (currentUser.isCollectionEditor && currentUser.isCollectionEditor.length > 0 && currentUser.isCollectionEditor.find((collectionID: any) => collectionID === item.Collection.get_lookupId())) || (currentUser.isCollectionAdmin && currentUser.isCollectionAdmin.length > 0 && currentUser.isCollectionAdmin.find((collectionID: any) => collectionID === item.Collection.get_lookupId()))) &&
                                        <button
                                            className="hover:text-darkblue flex"
                                            onClick={e => {
                                                e.stopPropagation();
                                                setTypeModal('Critical');
                                                setChangeDocument(item);
                                                setOpen(true);
                                            }}
                                        >
                                            <PencilIcon height="15" width="15" />
                                        </button>
                                    }
                                </FlexRow>
                            </FlexRow>
                        ))}
                    </FlexCol>
                    {customLoading &&
                        <FlexCol className="absolute pt-[60px] top-0 left-0 w-full h-full items-center justify-center min-h-[170px] max-h-[calc(100vh-210px)] bg-white/60">
                            <Loading />
                        </FlexCol>
                    }
                    {!customLoading && data.length === 0 &&
                        <FlexCol className="absolute pt-[60px] top-0 left-0 w-full h-full items-center justify-center min-h-[170px] max-h-[calc(100vh-210px)]">
                            <EmptyList title="Данные не найдены" />
                        </FlexCol>
                    }
                </div>
                {/* {!customLoading && data.length > 0 && <div className="w-full my-2 py-2 text-center bg-[#012169] text-white">Список сформирован</div>}
                {customLoading && <div className="w-full my-2 py-2 text-center animate-pulse">Формируется список, пожалуйста подождите</div>} */}
            </FlexCol>
            <Modal zIndex={70} open={open} toggleDialog={setOpen} modalClassName="min-h-px">
                {updateLoading &&

                    <FlexCol className="items-center justify-center w-full gap-2">
                        <span className="text-base text-darkblue">Обновляем данные...</span>
                        <Loading />
                    </FlexCol> ||
                    <>
                        {typeModal === 'Critical' &&
                            <>
                                <header className="px-10 pb-10">
                                    <h2>Изменение критичности</h2>
                                </header>
                                <div className="px-10 pb-8 border-b">
                                    <Select dataField={{
                                        width: 'w-full',
                                        require: false,
                                        title: 'Критичность',
                                        type: 'select',
                                        key: 'Critical',
                                        options: [{ id: 'Критичный', name: 'Критичный' }, { id: 'Не критичный', name: 'Не критичный' }]
                                    }} onChange={(value: any) => {
                                        setChangeDocument({ ...changeDocument, Critical: value.id === 'Критичный' && true || false });
                                        setChangeData({ ID: changeDocument.ID, Critical: value.id === 'Критичный' && true || false });
                                    }} value={{ id: changeDocument.Critical && 'Критичный' || 'Не критичный', name: changeDocument.Critical && 'Критичный' || 'Не критичный' }} />
                                </div>
                            </>
                        }
                        {typeModal === 'DateForRevision' &&
                            <>
                                <header className="px-10 pb-10">
                                    <h2>Изменение даты пересмотра</h2>
                                </header>
                                <div className="px-10 pb-8 border-b">
                                    <p className="text-base font-medium text-black mb-[10px]">Дата пересмотра</p>
                                    <Datepicker
                                        inputClassName="text-left cursor-default block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB] focus:outline-none"
                                        useRange={false}
                                        toggleClassName="absolute right-[20px] top-0 h-full px-3 text-gray-400 focus:outline-none disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB]"
                                        asSingle={true}
                                        i18n="ru"
                                        readOnly={true}
                                        primaryColor="blue"
                                        disabled={false}
                                        displayFormat="DD.MM.YYYY"
                                        value={{ startDate: changeDocument.DateForRevision, endDate: changeDocument.DateForRevision }}
                                        onChange={(value) => {
                                            setChangeDocument({ ...changeDocument, DateForRevision: value && value.startDate });
                                            setChangeData({ ID: changeDocument.ID, DateForRevision: value && value.startDate })
                                        }}
                                        placeholder="Введите дату"
                                    />
                                </div>
                            </>
                        }
                        {typeModal === 'ResponsibleForRevision' &&
                            <>
                                <header className="px-10 pb-10">
                                    <h2>Изменение ответственного за пересмотр</h2>
                                </header>
                                <div className="px-10 pb-8 border-b">
                                    <div className="relative w-full rounded-md shadow-sm">
                                        <PeoplePicker
                                            type=""
                                            dataField={{
                                                type: "peoplePicker",
                                                require: true,
                                                single: true,
                                                key: "Editors",
                                                current: false,
                                                title: "ФИО сотрудника",
                                                placeholder: "Введите имя сотрудника",
                                                width: "w-full",
                                            }}
                                            errors={{}}
                                            value={[{
                                                value: changeDocument.ResponsibleForRevisionEmail || changeDocument.ResponsibleForRevision.get_email().toLowerCase().trim(),
                                                label: users[changeDocument.ResponsibleForRevisionEmail || changeDocument.ResponsibleForRevision.get_email().toLowerCase().trim()]['displayName'],
                                                avatar: users[changeDocument.ResponsibleForRevisionEmail || changeDocument.ResponsibleForRevision.get_email().toLowerCase().trim()].avatar,
                                                email: changeDocument.ResponsibleForRevisionEmail || changeDocument.ResponsibleForRevision.get_email().toLowerCase().trim(),
                                            }]}
                                            onChange={(value) => {
                                                if (value && value.length > 0) {
                                                    dispatch(addUsers([value[0].value]));
                                                    setChangeDocument({ ...changeDocument, ResponsibleForRevisionEmail: value[0].value });
                                                    setChangeData({ ID: changeDocument.ID, ResponsibleForRevision: value[0].value, ResponsibleForRevisionEmail: value[0].value })
                                                }

                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        }
                        <footer className="px-10 mt-10 flex justify-between">
                            <TGButton color="white" onClick={() => setOpen(!open)}>
                                Отмена
                            </TGButton>
                            <TGButton onClick={updateDataHandle}>
                                Сохранить
                            </TGButton>
                        </footer>
                    </>
                }
            </Modal>
        </FlexCol>
    );
}

export default ReportDocumentsTable;

export function TableHeaderColumn({ tableHeaderContent, sortDataHandle, sortField }: any) {
    return (
        <FlexCol className="select-none" style={tableHeaderContent.style}>
            <FlexRow className="gap-x-2">
                {tableHeaderContent.icon && <FlexCol>{tableHeaderContent.icon}</FlexCol>}
                <FlexCol className="font-medium whitespace-pre-line w-fit">{tableHeaderContent.title}</FlexCol>
                {tableHeaderContent.sort && (
                    <FlexCol className="w-auto cursor-pointer" onClick={() => sortDataHandle(sortField, tableHeaderContent.sortDirection, tableHeaderContent.sortType)}>
                        <SortIcon sortDirection={tableHeaderContent.sortDirection} />
                    </FlexCol>
                )}
            </FlexRow>
        </FlexCol>
    );
}
